// Generated by Melange

import * as Buhta_landing__Link from "../../../components/html/Link.js";
import * as Buhta_landing__Route from "../../../Route.js";
import * as JsxRuntime from "react/jsx-runtime";

function NavbarMenuItem(Props) {
  let label = Props.label;
  let colorOpt = Props.color;
  let path = Props.path;
  const color = colorOpt !== undefined ? colorOpt : "text-black-landing";
  return JsxRuntime.jsx(Buhta_landing__Link.make, {
    route: Buhta_landing__Route.ofUrl(Buhta_landing__Route.getRouterUrl(path)),
    className: "ml-7.75 first:ml-0 cursor-pointer flex items-center transition-all duration-200 ease-in-out hover:text-primary paragraph-large " + color,
    children: label
  });
}

const make = NavbarMenuItem;

export {
  make,
}
/* Buhta_landing__Link Not a pure module */
